import React, { useState, useEffect } from "react";
import Header from "../../Component/Header/Header";
import Footer from "../../Component/Footer/Footer";
import axios from "axios";
import LazyLoader from "../../Component/LazyLoader";
import { AdviserUser, Surveybg, ThirdEye, logo } from "../../assets";
import {
  LockClosedIcon,
  PlayCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { Dialog, DialogBody, Typography } from "@material-tailwind/react";
import { Modal } from "flowbite-react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
// music player
import {
  AudioPlayerControlSprite,
  AudioPlayer,
  TrackType,
} from "react-audio-player-pro";
import reactAudioPlayerProStyle from "react-audio-player-pro/dist/style.css";
import AuthUser from "../../Component/AuthUser";
import Waveform from "../Meditation/waveform";

const Music = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { token, user } = AuthUser();
  const [subuser, setSubUser] = useState(false);
  React.useEffect(() => {
    axios
      .get(
        `https://api.drmeditation.net/api/subscription/mySubscription/${user?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        res.data.SubscribeUser.map((u) => {
          if (Number(u.user_id) === Number(user.id)) {
            setSubUser(true);
          }
        });
      });
  }, []);
  const [loading, setLoading] = useState(false);
  const [music, setMusic] = useState([]);
  const [selectedMusic, setSelectedMusic] = useState(null);
  // get api
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source");

  let apiToRender;
  if (source === "home") {
    apiToRender = `https://api.drmeditation.net/api/home/${id}`;
    //// console.log("from home", apiToRender);
  } else if (source === "result") {
    apiToRender = `https://api.drmeditation.net/api/myresult/show/${user.id}`;
    //// console.log("from result", apiToRender);
  } else {
    // handle invalid or missing source parameter
    //// console.log("nothing");
  }
  const getMusic = () => {
    axios
      .get(apiToRender, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        //// console.log(response.data.Audio);
        setMusic(response.data.Audio);
        setLoading(true);
      })
      .catch((error) => {
        // console.error(error);
      });
  };
  useEffect(() => {
    getMusic();
  }, []);

  const [open, setOpen] = useState(false);
  const handleOpen = (music) => {
    setSelectedMusic(music);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedMusic(null);
    setOpen(false);
  };
  return (
    <>
      <Header />
      <div className="Musicsbg h-[30rem]">
        <div className="container mx-auto h-full">
          <div className="flex flex-col justify-center items-start h-full px-4 sm:px-6 lg:px-8">
            <div className="border-l-2 border-black pl-4 sm:pl-8 md:pl-[2rem] lg:pl-[2rem] xl:pl-[2rem]">
              <h1 className="text-black text-3xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-4xl font-bold drop-shadow-lg shadow-black leading-tight">
                Our
                <br />
                <span>Music Gallery</span>
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-2xl mt-4 leading-tight">
                Music is a way towards
                <br />
                <span>meditation and the most</span>
                <br />
                <span>beautiful way.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="Treefooterbg pt-[3rem] pb-[3rem]  mx-auto">
        <h2 className=" pl-[2rem] pb-[2rem] text-[2rem] font-semibold text-center">
          Music
        </h2>
      </div>
      <div className="Treeblogsbg">
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-2">
            {loading ? (
              music.length ? (
                music.map((music) => (
                  <>
                    {subuser ? (
                      <>
                        <div
                          onClick={() => handleOpen(music)}
                          className=" py-[1rem]  cursor-pointer "
                        >
                          <div className="shadow-lg md:w-[20rem] md:h-[15rem] shadow-gray-500/50 max-w-sm bg-white border border-gray-200 rounded-lg hover:shadow-lg hover:shadow-gray-700/50 ">
                            <a>
                              <img
                                className="rounded-t-lg md:w-[20rem] h-[10rem] "
                                src={`https://api.drmeditation.net/AudioThumbnail/${music.thumbnail}`}
                                // src={Surveybg}
                                alt="logo"
                              />
                            </a>
                            <div className=" p-2">
                              <a>
                                <h5 className=" text-center text-xl truncate font-semibold tracking-tight text-gray-900 ">
                                  {music.name}
                                </h5>
                              </a>
                              <p className="mb-1 text-sm text-center font-normal text-gray-700  line-clamp-2">
                                {music.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : music.subscription === "free" ? (
                      <>
                        <div
                          onClick={() => handleOpen(music)}
                          className=" py-[1rem]  cursor-pointer "
                        >
                          <div className="shadow-lg md:w-[20rem] md:h-[15rem] shadow-gray-500/50 max-w-sm bg-white border border-gray-200 rounded-lg hover:shadow-lg hover:shadow-gray-700/50 ">
                            <a>
                              <img
                                className="rounded-t-lg md:w-[20rem] h-[10rem] "
                                src={`https://api.drmeditation.net/AudioThumbnail/${music.thumbnail}`}
                                // src={Surveybg}
                                alt="logo"
                              />
                            </a>
                            <div className=" p-2">
                              <a>
                                <h5 className=" text-xl text-center truncate font-semibold tracking-tight text-gray-900 ">
                                  {music.name}
                                </h5>
                              </a>
                              <p className="mb-1 text-sm text-center font-normal text-gray-700  line-clamp-2">
                                {music.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className=" relative py-[1rem]  cursor-pointer "
                          onClick={() => navigate("/subscriptions")}
                        >
                          <div className="absolute z-10 text-black  p-4 rounded-full bottom-[5%] right-[2%] ">
                            <LockClosedIcon className="h-7 w-7 " />
                          </div>
                          <div className="shadow-lg md:w-[20rem] md:h-[15rem] shadow-gray-500/50 max-w-sm bg-white border border-gray-200 rounded-lg hover:shadow-lg hover:shadow-gray-700/50  ">
                            <a>
                              <img
                                className="rounded-t-lg md:w-[20rem] h-[10rem] "
                                src={`https://api.drmeditation.net/AudioThumbnail/${music.thumbnail}`}
                                // src={Surveybg}
                                alt="logo"
                              />
                            </a>
                            <div className="md:p-5 p-2">
                              <a>
                                <h5 className="mb-2 text-xl text-center truncate font-bold tracking-tight text-gray-900 ">
                                  {music.name}
                                </h5>
                              </a>
                              <p className="mb-3 text-sm text-center font-normal text-gray-700  line-clamp-2">
                                {music.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ))
              ) : (
                <p className="text-center md:pt-[1rem] text-xl font-semibold">
                  There are no musics in this Category.
                </p>
              )
            ) : (
              <LazyLoader />
            )}
            {selectedMusic && (
              <Modal show={open} onClose={handleClose} size="lg">
                <Modal.Body className="bg-[#d2e8b6]  rounded-sm">
                  <>
                    <div className="flex justify-end">
                      <XMarkIcon
                        color="red"
                        strokeWidth={2}
                        onClick={handleClose}
                        className="h-5 w-5 cursor-pointer	 hover:rounded-md hover:bg-blue-gray-100"
                      />
                    </div>
                    <div className="flex justify-center items-center flex-col">
                      <div className="RoundBorder ">
                        <div className="relative right-1 bottom-1">
                          <img
                            className="rounded-full h-40 w-40 p-4 "
                            src={`https://api.drmeditation.net/AudioThumbnail/${selectedMusic.thumbnail}`}
                            // src={Surveybg}
                            alt="logo"
                          />
                        </div>
                      </div>
                      <br></br>
                      <Typography className="text-black" variant="h5">
                        {selectedMusic.name}
                      </Typography>

                      <br></br>
                      <div className="px-3">
                        <div className="flex justify-center items-center w-58 ">
                          <AudioPlayerControlSprite />
                          <AudioPlayer
                            trackList={[
                              {
                                src: `https://api.drmeditation.net/Audio/${selectedMusic.audio}`,
                                // src: ThirdEye,
                                preload: "auto",
                                // duration: 100,
                                mediaMetadata: {
                                  title: selectedMusic.name,
                                },
                              },
                            ]}
                            // string - wrapper's class name, optional, deafult: ''
                            className="my-class-name flex justify-center w-[30rem] mb-4 "
                            // callback function - called on did mount, optional, default: noop
                            // onDidMount={//// console.log}
                            // default player state, optional
                            defaultState={{
                              // boolean - is player muted, optional, default: false
                              isMuted: false,

                              // number - active song index, optional, default: 0
                              activeIndex: 0,

                              // boolean - is shuffle on, optional, default: false
                              isShuffleOn: false,

                              // boolean - is track list open, optional, default: true
                              isTrackListOpen: false,

                              // string: 'none' | 'all' | 'one' - repeating state, optional, default: 'none'
                              repeatingState: "one",
                            }}
                          />
                        </div>
                      </div>

                      {/* <Waveform
                        audio={ThirdEye}
                        // audio={`https://api.drmeditation.net/Audio/${selectedMusic.audio}`}
                      /> */}
                    </div>
                  </>
                </Modal.Body>
              </Modal>
            )}
          </div>
        </div>
      </div>
      <div className="mt-[-0.5rem]">
        <Footer />
      </div>
    </>
  );
};

export default Music;
